<template>
	<div class="top-bar">
		<div class="left">
			<v-btn @click="toggleMenu()" class="mr-4" icon><v-icon>mdi-menu</v-icon></v-btn>
		</div>

		<div class="right">
            <div style="float: left">
                <a :href="shopLink()" target="_blank" style="text-decoration: underline;">website content adjustment</a>
            </div>
			<div class="user-box">

				<v-avatar size="48" :color="false ? '' : 'primary'">
					<img v-if="false" alt="Avatar" src="https://avatars0.githubusercontent.com/u/9064066?v=4&s=460">
					<v-icon v-else color="white">mdi-account</v-icon>
				</v-avatar>

				<v-btn class="ml-2" icon small link @click="logout()">
					<v-icon>mdi-logout</v-icon>
				</v-btn>
			</div>

			<v-menu class="mobile-user" bottom min-width="200px" rounded offset-y >
				<template v-slot:activator="{ on }">
					<v-btn class="mobile-user" icon x-large v-on="on" >
						<v-avatar size="48" :color="false ? '' : 'primary'">
							<img v-if="false" alt="Avatar" src="https://avatars0.githubusercontent.com/u/9064066?v=4&s=460">
							<v-icon v-else color="white">mdi-account</v-icon>
						</v-avatar>
					</v-btn>
				</template>
				<v-card>
					<v-list-item-content class="justify-center">
						<div class="mx-auto text-center">
							<v-btn depressed rounded text> Settings</v-btn>
							<v-divider class="my-3"></v-divider>
							<v-btn depressed rounded text link @click="logout()"> Logout </v-btn>
							</div>
					</v-list-item-content>
				</v-card>
			</v-menu>
		</div>
	</div>
</template>

<script>
	import { logout } from '../../api/common';

	import './style.scss';

	export default {
		name: 'TopBar',
		components: {},
        data: () => {
            return {
                shopLink: function () {
                    let result = location.host.split('.').splice(-2).join('.');
                    if (location.host.split('.').includes('stage')) {
                        result = 'stage.' + result;
                    }
                    return location.protocol + '//' + result+ '/#shop';
                }
            }
        },

		methods: {
			toggleMenu(){
				this.$store.dispatch('Common/toggleMenu');
			},

			logout(){
				let bodyFormData = new FormData();

				return new Promise((resolve, reject) => {
					logout(bodyFormData).then(res => {

						this.$router.push('/login');
					}).catch(error => {
						console.log(error);
						this.$store.dispatch('Common/setError', error.data, { root: true });

						reject(error);
					})
				});

			}
		}
	}
</script>

<style>

</style>
